const configS3 = (bucketName, dirName) => {
  return {
    bucketName: bucketName,
    dirName: dirName || "data" /* optional */,
    region: process.env.VUE_APP_S3_REGION,
    accessKeyId: process.env.VUE_APP_S3_KEYID,
    secretAccessKey: process.env.VUE_APP_S3_ACCESSKEY,
    // region: "us-east-1", //dev
    // region: "ap-southeast-1", //prod
    // accessKeyId: "AKIAVLDCOUNBDIMPECMX", // dev
    // secretAccessKey: "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",
    // accessKeyId: "AKIAVLDCOUNBJUPM7NQ3", // Prod
    // secretAccessKey: "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",
  };
};

export default configS3;
